<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="工作量核算标准" name="workloadAccountingStandards"> </el-tab-pane>
        <el-tab-pane label="提成核算" name="commissionAccounting"> </el-tab-pane>
        <el-tab-pane label="提成系数" name="commissionCoefficient"> </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent"></component>
    </content-panel>
  </div>
</template>

<script>
import workloadAccountingStandards from "./workloadAccountingStandards/workloadAccountingStandards";
import commissionAccounting from "./commissionAccounting/commissionAccounting";
import commissionCoefficient from "./commissionCoefficient/commissionCoefficient";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "FilmRepairmanSalaryAllocation",
  mixins: [pagePathMixin],
  components: { workloadAccountingStandards, commissionAccounting, commissionCoefficient },
  data() {
    return {
      activeName: "workloadAccountingStandards",
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  mounted() {
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
</style>
